<template>
  <div id="pers-tab18" name="hres31x-tab18" class="content-pers" :class="{'-fixed-height-box' : pcDisp}">
    <template v-for="(value, index) in detail.tablePersonRef.rows">
      <detail-template
        :index="index"
        :labels="labels"
        :detail="detail"
        inline-template>
        <div>
          <div slot="head" class="sub-topic-box color-skin" @click="toggleDisp()">
            <i class="fa fa-user icon-sub-topic" aria-hidden="true"></i>
            <div class="sub-topic">{{ labels['HRES31XC17']['10'] }} ( {{ labels['HRES31XC17']['20'] }}  {{ index + 1 }} )</div>
          </div>

          <div slot="body" class="data-pers-box" v-show="topicDisp">
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['30'] }}</div>
              <div class="col-xs-6 data-text">{{ value.namref }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['40'] }}</div>
              <div class="col-xs-6 data-text">{{ value.flgref }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['50'] }}</div>
              <div class="col-xs-6 data-text">{{ value.desnoffi }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['60'] }}</div>
              <div class="col-xs-6 data-text">{{ value.despos }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['70'] }}</div>
              <div class="col-xs-6 data-text">{{ value.numtele }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['80'] }}</div>
              <div class="col-xs-6 data-text">{{ value.adrcont1 }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['90'] }}</div>
              <div class="col-xs-6 data-text">{{ value.email }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['100'] }}</div>
              <div class="col-xs-6 data-text">{{ value.codoccup }}</div>
            </div>
            <div class="row data-box">
              <div class="col-xs-6 data-label">{{ labels['HRES31XC17']['110'] }}</div>
              <div class="col-xs-6 data-text">{{ value.remark }}</div>
            </div>
          </div>
        </div>
      </detail-template>
    </template>
  </div>
</template>

<script>
import detailTemplate from 'components/hres31x/detailTemplate'

export default {
  name: 'hres31x-tab18',
  components: {
    detailTemplate
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'triggerButton' ]
}
</script>


// WEBPACK FOOTER //
// tab18.vue?ac41d416